<template>
  <div class="top-bar">
    <div class="top-bar__top-wrapper">
      <router-link :to="{name: 'home'}"><logo /></router-link>
      <span class="top-bar__wizard" v-if="stepNumber && !skipStep"><span class="m-hidden">{{ wizardText }}</span> <strong>{{ stepNumber }}</strong> / {{ totalSteps }}</span>
    </div>

    <header class="top-bar__header">
      <transition name="fade" mode="out-in">
        <button class="top-bar__back btn-link" v-if="canGoBack && !skipStep" @click="goBack">
          <img class="icon" src="/static/images/icons/ic_arrow_left.svg" :alt="$t('back')">
          <span class="underlined">{{ $t('back') }}</span>
        </button>
      </transition>

      <transition name="fade" mode="out-in">
        <h1 class="margin-bottom-0" :key="header">
          {{ header }}
        </h1>
      </transition>
      <transition name="fade" mode="out-in">
        <h3 class="margin-bottom-0 margin-top-0" v-if="subHeader" :key="subHeader">
          {{ subHeader }}
        </h3>
      </transition>
      <transition name="fade" mode="out-in">
        <p class="margin-top-ms" v-if="description" :key="description">
          {{ description }}
        </p>
      </transition>
    </header>
  </div>
</template>

<script>
import Logo from './Logo'
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'header', 'description',
      'subHeader', 'stepNumber',
      'totalSteps', 'wizardText',
      'canGoBack', 'skipStep'
    ]),

    previousRoute () {
      if (this.previousRouteName) {
        return { name: this.previousRouteName }
      }
    }
  },

  methods: {
    ...mapActions(['goBack'])
  },

  components: {
    Logo
  }
}
</script>




// WEBPACK FOOTER //
// TopBar.vue?00e7c882